<div
  class="portal">
  <div
    #portalTop
    class="portal__overlay portal__top"
  ></div>
  <div
    #portalLeft
    class="portal__overlay portal__left"
  ></div>
  <div
    #portalRight
    class="portal__overlay portal__right"
  ></div>
  <div
    #portalBottom
    class="portal__overlay portal__bottom"
  ></div>
  <div
    #portal
    [ngClass]="{'portal__contents--no-events': !stepPortal.exposedElement}"
    class="portal__contents"
    data-cy="guided-tour.portal"
  ></div>
</div>
